import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
    "inline-flex items-center rounded-lg border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default: "border-transparent bg-primary-100 text-primary-600",
                secondary: "border-transparent bg-gray-100 text-gray-700",
                destructive: "border-transparent bg-red-100 text-red-600",
                outline: "text-gray-900",
                success: "border-transparent bg-green-100 text-green-600",
                warning: "border-transparent bg-yellow-100 text-yellow-600",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

function Badge({ className, variant, ...props }) {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    )
}

export { Badge, badgeVariants }

